import { z } from 'zod';

// ---------------------------------------------------------------------------
// Merkede id-typer – gir typesikkerhet på tvers av domeneobjekter.
// ---------------------------------------------------------------------------

export const CaseIdSchema = z.string().min(1, 'CaseId kan ikke være tom').brand<'CaseId'>();
export type CaseId = z.infer<typeof CaseIdSchema>;

export const SourceIdSchema = z.string().min(1, 'SourceId kan ikke være tom').brand<'SourceId'>();
export type SourceId = z.infer<typeof SourceIdSchema>;

export const SourceItemIdSchema = z
  .string()
  .min(1, 'SourceItemId kan ikke være tom')
  .brand<'SourceItemId'>();
export type SourceItemId = z.infer<typeof SourceItemIdSchema>;

export const PersonIdSchema = z.string().min(1, 'PersonId kan ikke være tom').brand<'PersonId'>();
export type PersonId = z.infer<typeof PersonIdSchema>;

export const OrgIdSchema = z.string().min(1, 'OrgId kan ikke være tom').brand<'OrgId'>();
export type OrgId = z.infer<typeof OrgIdSchema>;

export const DocumentIdSchema = z
  .string()
  .min(1, 'DocumentId kan ikke være tom')
  .brand<'DocumentId'>();
export type DocumentId = z.infer<typeof DocumentIdSchema>;

export const EventIdSchema = z.string().min(1, 'EventId kan ikke være tom').brand<'EventId'>();
export type EventId = z.infer<typeof EventIdSchema>;

export const PeriodIdSchema = z.string().min(1, 'PeriodId kan ikke være tom').brand<'PeriodId'>();
export type PeriodId = z.infer<typeof PeriodIdSchema>;

export const RelationIdSchema = z
  .string()
  .min(1, 'RelationId kan ikke være tom')
  .brand<'RelationId'>();
export type RelationId = z.infer<typeof RelationIdSchema>;

export const UserIdSchema = z.string().min(1, 'UserId kan ikke være tom').brand<'UserId'>();
export type UserId = z.infer<typeof UserIdSchema>;

export const ImportJobIdSchema = z
  .string()
  .min(1, 'ImportJobId kan ikke være tom')
  .brand<'ImportJobId'>();
export type ImportJobId = z.infer<typeof ImportJobIdSchema>;

export const AuditLogIdSchema = z
  .string()
  .min(1, 'AuditLogId kan ikke være tom')
  .brand<'AuditLogId'>();
export type AuditLogId = z.infer<typeof AuditLogIdSchema>;

export const InvitationIdSchema = z
  .string()
  .min(1, 'InvitationId kan ikke være tom')
  .brand<'InvitationId'>();
export type InvitationId = z.infer<typeof InvitationIdSchema>;

// ---------------------------------------------------------------------------
// Felles primitiver
// ---------------------------------------------------------------------------

/** ISO 8601 UTC-timestamp, f.eks. "2025-04-10T09:14:00.000Z" */
export const IsoTimestampSchema = z
  .string()
  .datetime({ offset: true, message: 'Ugyldig ISO 8601-timestamp' });
export type IsoTimestamp = z.infer<typeof IsoTimestampSchema>;

/** RFC 5321-kompatibel e-postadresse */
export const EmailSchema = z.string().email('Ugyldig e-postadresse').toLowerCase();
export type Email = z.infer<typeof EmailSchema>;

/**
 * Telefonnummer på E.164-format, f.eks. "+4798765432".
 * Tillater opptil 15 siffer etter landkoden.
 */
export const PhoneSchema = z
  .string()
  .regex(/^\+[1-9]\d{1,14}$/, 'Telefonnummer må være på E.164-format (f.eks. +4798765432)');
export type Phone = z.infer<typeof PhoneSchema>;

/** SHA-256 hex-digest (64 hex-tegn) */
export const Sha256HashSchema = z
  .string()
  .regex(/^[a-f0-9]{64}$/, 'Hash må være SHA-256 hex (64 tegn)');
export type Sha256Hash = z.infer<typeof Sha256HashSchema>;
